import styled from 'styled-components';

import Button from 'components/button';
import { Flex } from 'components/flex';
import Icons from 'components/icons/Icons';
import Typography from 'components/typography';

interface CardSellProps {
  labelTitle?: string;
  title?: string;
  labelSubTitle?: string;
  subtitle?: string;
  footer?: string;
  placeholder?: string;
  onClick?: () => void;
}

const WhiteBox = styled(Flex)`
  border-radius: 4px 4px 0 0;
  padding: ${({ theme }) => theme.space[5] + 'px'};
`;

const BlackBox = styled(Flex)`
  padding: ${({ theme }) => theme.space[5] + 'px'};
`;

const Icon = styled(Icons)`
  display: flex;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 16px;

      ${mediaQueries.desktop} {
        width: 20px;
      }
    `;
  }}
`;

const CardSell = ({ labelTitle, title, labelSubTitle, subtitle, footer, placeholder, onClick }: CardSellProps) => {
  return (
    <Flex flexGrow={0} width={{ m: '100%', t: 370 }} mt={{ m: 30, d: 0 }}>
      <Flex flexDirection={'column'} width={{ m: '100%', t: 370 }}>
        <WhiteBox flexGrow={0} flexDirection={'column'} flexShrink={0} bg="white">
          <Typography as="h2" type="type0" upper color="gray_500" lineHeight={1.5}>
            {labelTitle}
          </Typography>
          <Typography as="h2" type="type7" color="dark_350" fontWeight="bold">
            {title}
          </Typography>
        </WhiteBox>
        <BlackBox flexGrow={0} flexDirection={'column'} flexShrink={0} bg="dark_350">
          <Typography as="h2" type="type0" upper color="gray_500" lineHeight={1.5}>
            {labelSubTitle}
          </Typography>
          <Typography as="h1" type="type5" color="white">
            {subtitle}
          </Typography>
          <Typography as="h2" type="type0" color="white" lineHeight="3">
            {footer}
          </Typography>
        </BlackBox>
        <Button size="card" onClick={onClick} color="black" square>
          <Flex flexDirection={'row'} justifyContent="space-between" alignItems="center">
            <span>{placeholder}</span>
            <Icon icon={'arrowRight'} />
          </Flex>
        </Button>
      </Flex>
    </Flex>
  );
};

export default CardSell;
